import {
  createStore,
  applyMiddleware,
  compose
} from 'redux';
import rootReducer from 'reducers';
import createSagaMiddleware from 'redux-saga';
import rootSaga from 'sagas';

const sagaMiddleware = createSagaMiddleware()

export default {
  createStore: (initialState) => createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(
        sagaMiddleware
      ),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  ),
  runSagas: () => sagaMiddleware.run(rootSaga)
};


/**
export default (initialState) => createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(
      sagaMiddleware
    ),
    window.devToolsExtension ? window.devToolsExtension() : f => f
  )
);

sagaMiddleware.run(rootsaga);
*/


// WEBPACK FOOTER //
// ./src/configure/store.js